import functionUncurryThis from './function-uncurry-this.js';

var uncurryThis = functionUncurryThis;
var arraySlice = uncurryThis([].slice);

export { arraySlice as default };
